import React from "react";
import PremiumAccess from "../PremiumAccess";

const OuCell = ({ scheduleItem, isHome, freeGame }: { scheduleItem: any; isHome: boolean; freeGame: boolean }) => {
  const total = scheduleItem.line?.total ?? 0;
  const selfTeamScore = scheduleItem[`${isHome ? "home" : "away"}Score`];
  const opponentTeamScore = scheduleItem[`${isHome ? "away" : "home"}Score`];

  if (selfTeamScore === null && opponentTeamScore === null) {
    return (
      <PremiumAccess freeGame={freeGame} scheduleItem={scheduleItem} source="O/U Cell" graybar>
        <span className="schedule-list__table-cell schedule-list__table-item-5">{total > 0 ? total : "--"}</span>
      </PremiumAccess>
    );
  }

  const totalTeamScore = selfTeamScore + opponentTeamScore;
  const totalOverUnder = totalTeamScore === total ? "P" : totalTeamScore > total ? "O" : "U";

  return (
    <PremiumAccess freeGame={freeGame} scheduleItem={scheduleItem} source="O/U Cell" graybar>
      <span className="schedule-list__table-cell schedule-list__table-item-5">
        {total > 0 ? `${totalOverUnder} ${total}` : "--"}
      </span>
    </PremiumAccess>
  );
};

export default OuCell;
